import { render, staticRenderFns } from "./EmployeeChatterView.vue?vue&type=template&id=f9f39624"
import script from "./EmployeeChatterView.vue?vue&type=script&lang=js"
export * from "./EmployeeChatterView.vue?vue&type=script&lang=js"
import style0 from "./EmployeeChatterView.vue?vue&type=style&index=0&id=f9f39624&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports